import React from 'react'
import Style from './Content.css'
import SectionLabel from '../SectionLabel/SectionLabel'
import Button from '../Button/Button'
import taylor from '../../assets/Taylor.jpg'
import who from '../../assets/Who-We-Are-Image.jpg'

const Who = () => {
  return (
    <section className="pt-10">
      <div className="container">
        <SectionLabel
          heading={'Who We Are'}
          body={'An ambitious group of individuals using our talents to make an impact.'}
          styles={'font-color-arizona-blue pb-6 max-md:text-center'}
        />
        <div className=" md:flex pt-2 relative items-start">
          <div className="stats md:pt-10">
            <div className="font-color-arizona-blue stats-list bg-color-sky p-8">
              <div className="md:flex max-md:text-center ">
                <div className="basis-1/2 relative">
                  <div className="line max-md:hidden vertical-line azBlue"></div>
                  <div className="md:pl-6">
                    <p className="text-2xl font-black condensed ">4,000+</p>
                    <p className="italic font-semibold">students</p>
                  </div>
                  <div className="mt-6 horizontal-line azBlue md:hidden max-w-[90px] ml-auto mr-auto"></div>
                </div>
                <div>
                  <div className="relative">
                    <div className="line  max-md:hidden vertical-line azBlue"></div>
                    <div className="md:pl-6">
                      <p className="text-2xl font-black condensed max-md:pt-4">100+</p>
                      <p className="italic font-semibold">dedicated faculty and staff</p>
                    </div>
                    <div className="mt-6 horizontal-line md:hidden azBlue max-w-[90px] ml-auto mr-auto"></div>
                  </div>
                </div>
              </div>
              <div className="md:flex pt-4 max-md:text-center">
                <div className="basis-1/2 relative">
                  <div className="line  max-md:hidden vertical-line azBlue"></div>
                  <div className="md:pl-6">
                    <p className="text-2xl font-black condensed max-md:pt-4">3.9</p>
                    <p className="italic font-semibold">average incoming GPA</p>
                  </div>
                  <div className="mt-6 horizontal-line md:hidden azBlue max-w-[90px] ml-auto mr-auto"></div>
                </div>
                <div className="relative">
                  <div className="line  max-md:hidden vertical-line azBlue"></div>

                  <div className="md:pl-6">
                    <p className="text-2xl font-black condensed max-md:pt-4">250+</p>
                    <p className="italic font-semibold">honors-specific courses</p>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div className="bg-color-arizona-blue p-8 honors-village text-center">
              <div className="text-white pl-4 pr-4 relative">
                <div className="line max-md:hidden vertical-line bloom  "></div>
                <div className="mt-6 horizontal-line md:hidden bloom max-w-[90px] ml-auto mr-auto mb-4"></div>

                <div>
                  <p className="text-2xl font-black condensed">Honors Village</p>
                  <p className="italic font-semibold">
                    Franke Honors students, faculty, classes, and support under one roof
                  </p>
                </div>
              </div>
              <div className="md:hidden pt-6">
                <img className="" src={who} />
              </div>
            </div>
          </div>
          <div className="hidden md:block who-image-container ">
            <img className="who-image" src={who} />
          </div>
        </div>
        <div className="md:flex pt-8 md:pt-14 font-color-arizona-blue justify-between">
          <div className="max-w-[749px]">
            Our mission? Empower you to reveal and pursue your passions with a deeper sense of
            wonder and purpose. Backed by a supportive community and a powerhouse research
            university, there’s so much you can achieve.
          </div>
          <div className="who-button-wrap text-white">
            <Button
              linkId="get-to-know-us"
              className="border-white "
              link="https://frankehonors.arizona.edu/news/student-profiles"
            >
              Get To Know Us
            </Button>
          </div>
        </div>
        <div className="md:flex pt-8 md:pt-16 who-quote font-color-arizona-blue font-semibold">
          <div className="max-md:hidden">
            <img src={taylor} width="346" />
          </div>
          <div className="md:max-w-[430px]">
            <p className="italic">
              “I was drawn to the community-based culture here. You can tell people care about you
              as a student. The faculty and staff are here to help you achieve your goals.”
            </p>
            <p className="pt-2 signature">— Taylor, Physiology and Medical Sciences</p>
            <div className="sig-image2 max-md:block md:hidden ">
              <img src={taylor} width="235" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Who
